const fontFamily = ['Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'].join(',');
// New Font
const fontFamilyV2 = ['Basier Square', 'Verdana', 'sans-serif'].join(',');
export const typography = {
    fontFamily,
    fontFamilyV2,
};
//# sourceMappingURL=typography.js.map